import React from 'react';
import { Badge } from './ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import {
  Clock,
  CheckCircle,
  XCircle,
  Send
} from 'lucide-react';

const PurchaseApprovalBadge = ({
  status,
  size = 'small',
  showIcon = true,
  tooltip = true
}) => {
  const getApprovalConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return {
          label: '待审批',
          variant: 'warning',
          icon: <Clock className="h-3 w-3" />,
          tooltip: '等待管理员审批'
        };
      case 'approved':
        return {
          label: '已批准',
          variant: 'success',
          icon: <CheckCircle className="h-3 w-3" />,
          tooltip: '已通过审批'
        };
      case 'rejected':
        return {
          label: '已拒绝',
          variant: 'destructive',
          icon: <XCircle className="h-3 w-3" />,
          tooltip: '审批已被拒绝'
        };
      case 'submitted':
        return {
          label: '已提交',
          variant: 'secondary',
          icon: <Send className="h-3 w-3" />,
          tooltip: '已提交等待审批'
        };
      default:
        return {
          label: status || '未知',
          variant: 'outline',
          icon: <Clock className="h-3 w-3" />,
          tooltip: '审批状态未知'
        };
    }
  };

  const config = getApprovalConfig(status);

  // Map variants to appropriate classes
  const variantClasses = {
    warning: 'bg-warning/20 text-warning border-warning/20',
    success: 'bg-success/20 text-success border-success/20',
    destructive: 'bg-destructive/20 text-destructive border-destructive/20',
    secondary: 'bg-primary/20 text-primary border-primary/20',
    outline: 'bg-muted text-foreground border-gray-200'
  };

  const badge = (
    <Badge
      variant="outline"
      className={`${variantClasses[config.variant]} ${size === 'small' ? 'text-xs' : 'text-sm'}`}
    >
      {showIcon && <span className="mr-1">{config.icon}</span>}
      {config.label}
    </Badge>
  );

  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {badge}
          </TooltipTrigger>
          <TooltipContent>
            <p>{config.tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return badge;
};

export default PurchaseApprovalBadge;
